module.exports = __webpack_public_path__ + "static/media/Option1ProfPic.2b16b370.png";